<template>
  <v-container grid-list-md fluid text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap style="height: 85vh; overflow: scroll">
      <v-expansion-panel v-model="panel" expand>
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-toolbar-title>Dashboard</v-toolbar-title>
          </template>
          <div
            v-show="!loadingDashboard"
            :class="['c_row', 'py-3', 'px-5', loadingDashboard ? '_gray' : '']"
          >
            <CardDashboard
              title="Aforo Actual"
              :total="dashboardData.studentTotal"
              :today="dashboardData.capacity"
              :isAforo="true"
              toNamedRoute="AllREport"
            >
              <v-icon size="30" color="primary">group</v-icon>
            </CardDashboard>
            <CardDashboard
              title="Asistencia Alumnos"
              :total="dashboardData.studentTotal"
              :today="dashboardData.studentEntries"
              :yesterday="dashboardData.previousDay.studentEntries"
              toNamedRoute="attendanceReport"
            >
              <img :src="require('@/assets/icons/dashboard_list.svg')" alt="" />
            </CardDashboard>
            <CardDashboard
              title="Salida Alumnos"
              :total="dashboardData.studentEntries"
              :today="dashboardData.studentDepartures"
              :yesterday="dashboardData.previousDay.studentDepartures"
              toNamedRoute="Outings"
            >
              <img :src="require('@/assets/icons/arrive.svg')" alt="" />
            </CardDashboard>
            <CardDashboard
              title="Asistencia Colaboradores"
              :total="dashboardData.collaboratorTotal"
              :today="dashboardData.collaboratorEntries"
              :yesterday="dashboardData.previousDay.collaboratorEntries"
              toNamedRoute="HistoricReport"
            >
              <img :src="require('@/assets/icons/evaluate.svg')" alt="" />
            </CardDashboard>
            <CardDashboard
              title="Salida Colaboradores"
              :total="dashboardData.collaboratorEntries"
              :today="dashboardData.collaboratorDepartures"
              :yesterday="dashboardData.previousDay.collaboratorDepartures"
              toNamedRoute="HistoricReport"
            >
              <img :src="require('@/assets/icons/exit_building.svg')" alt="" />
            </CardDashboard>
          </div>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-toolbar-title>{{ $t('home.title') }}</v-toolbar-title>
          </template>
          <div class="scroll-y scrollDesign" style="max-height: 80vh">
            <v-flex xs12 mt-1>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm3
                  md3
                  l2
                  xl2
                  v-for="item in menu"
                  :key="item.nombre"
                  @click="pushRoute(item)"
                  v-show="permits[item.permit]"
                >
                  <v-hover class="zoomD">
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 4 : 0}`"
                    >
                      <v-expand-transition
                        v-if="
                          item.permit != 'WATCH_CART' && !permits[item.permit]
                        "
                      >
                        <div
                          v-if="hover"
                          class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-1 white--text"
                          style="height: 100%; z-index: 1"
                        >
                          {{ $t('home.unAuthorized') }}
                        </div>
                      </v-expand-transition>
                      <v-expand-transition v-if="item.permit == 'WATCH_CART'">
                        <div
                          v-if="hover"
                          class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-1 white--text"
                          style="height: 100%; z-index: 1"
                        >
                          {{ $t('home.inDevelopment') }}
                        </div>
                      </v-expand-transition>
                      <v-card-title primary-title>
                        <v-flex
                          xs12
                          v-if="item.nombre == 'Actualizaciones'"
                          @click="teste()"
                        >
                          <v-layout row wrap justify-center>
                            <v-flex xs6>
                              <v-badge
                                style="float: right"
                                bordered
                                overlap
                                color="#ff0000"
                                v-show="statusUp()"
                              >
                                <template v-slot:badge>
                                  <span>{{ num }}</span>
                                </template>
                              </v-badge>
                              <v-img
                                :src="
                                  require('@/assets/panel/home/' +
                                    item.iconImage)
                                "
                              ></v-img>
                            </v-flex>
                          </v-layout>
                          <div class="headline">{{ $t(item.name) }}</div>
                          <span>{{ $t(item.descriptiion) }}</span>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <v-layout row wrap justify-center>
                            <v-flex xs6>
                              <v-img
                                :src="
                                  require('@/assets/panel/home/' +
                                    item.iconImage)
                                "
                              ></v-img>
                            </v-flex>
                          </v-layout>
                          <div class="headline">{{ $t(item.name) }}</div>
                          <span>{{ $t(item.descriptiion) }}</span>
                        </v-flex>
                      </v-card-title>
                    </v-card>
                  </v-hover>
                </v-flex>
                <v-flex
                  xs12
                  sm3
                  md3
                  l2
                  xl2
                  v-for="item in worshopsModules"
                  :key="item.nombre"
                  @click="pushRoute(item)"
                  v-show="!isNormalSchool_()"
                >
                  <v-hover class="zoomD">
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 4 : 0}`"
                    >
                      <v-card-title primary-title>
                        <v-flex xs12>
                          <v-layout row wrap justify-center>
                            <v-flex xs6>
                              <v-img
                                :src="
                                  require('@/assets/panel/home/' +
                                    item.iconImage)
                                "
                              />
                            </v-flex>
                          </v-layout>
                          <div class="headline">
                            {{ $t(item.name) }}
                          </div>
                          <span>{{ $t(item.descriptiion) }}</span>
                        </v-flex>
                      </v-card-title>
                    </v-card>
                  </v-hover>
                </v-flex>
                <v-flex xs12 sm3 md3 l2 xl2>
                  <v-hover class="zoomD">
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 4 : 0}`"
                    >
                      <a
                        style="color: #000000; text-decoration: none"
                        href="https://sites.google.com/kiritek.com/centrodeayudaskolable"
                        target="_blank"
                      >
                        <v-card-title primary-title>
                          <v-flex xs12>
                            <v-layout row wrap justify-center>
                              <v-flex xs6>
                                <v-img
                                  :src="
                                    require('@/assets/panel/home/SKLB-Help.png')
                                  "
                                ></v-img>
                              </v-flex>
                            </v-layout>
                            <div class="headline">Centro de ayuda</div>
                            <span
                              >Herramienta web donde compartimos material de
                              apoyo acerca de Skolable</span
                            >
                          </v-flex>
                        </v-card-title>
                      </a>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
    <GlobalPollsModal />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import GlobalPollsModal from '../../Modals/GlobalPollsModal.vue'
import CardDashboard from '../../generic/cardDashboard.vue'

export default {
  components: {
    CardDashboard,
    GlobalPollsModal,
  },
  data: () => ({
    panel: [true, true],
    permits: [],
    worshopsModules: [
      {
        nombre: 'Talleres',
        name: 'panel.workshop',
        descriptiion: 'panel.workshopDesc',
        route: 'workshop',
        activo: false,
        icon: 'home_repair_service',
        iconSelected: 'home_repair_service',
        desc: 'Visualiza, administra, descarga y crea nuevos talleres',
        iconImage: 'Workshop.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Salones',
        name: 'panel.classroom',
        descriptiion: 'panel.classroomDesc',
        route: 'classroom',
        activo: false,
        icon: 'meeting_room',
        iconSelected: 'meeting_room',
        desc: 'Visualiza, administra, descarga y crea nuevos salones ',
        iconImage: 'Classroom.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Días de asueto',
        name: 'panel.holiday',
        descriptiion: 'panel.holidayDesc',
        route: 'holidays',
        activo: false,
        icon: 'celebration',
        iconSelected: 'celebration',
        desc: 'Visualiza, administra, descarga y crea días de asueto ',
        iconImage: 'Holiday.png',
        permit: 'WATCH_VISITS',
      },
    ],
    versionAdmin: '',
    versionStaff: '',
    versionTutorA: '',
    versionTutorIO: '',
    set: '',
    num: 0,
    loadingDashboard: false,
    dashboardData: {
      studentTotal: 0,
      collaboratorTotal: 0,
      capacity: 0,
      studentEntries: 0,
      studentDepartures: 0,
      collaboratorEntries: 0,
      collaboratorDepartures: 0,
      previousDay: {
        studentEntries: 0,
        studentDepartures: 0,
        collaboratorEntries: 0,
        collaboratorDepartures: 0,
      },
    },
  }),
  watch: {
    getUser() {
      this.mapPermits()
    },
    getBranch() {
      this._subscribeWs()
    },
  },
  mounted() {
    if (this.getUser && this.getUser.id) this.mapPermits()
    this.getDashboard()
    this._subscribeWs()
  },
  beforeDestroy() {
    this._unSubscribeWs()
  },
  methods: {
    async getDashboard() {
      this.loadingDashboard = true
      try {
        const { data } = await this.$store.dispatch('dashboard/getDashboard')
        this.dashboardData = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingDashboard = false
      }
    },
    isNormalSchool_() {
      return isNormalSchool(this.getBranch)
    },
    contUpdate() {
      this.num = 0
      if (localStorage.getItem('APP_VERSION') != this.versionAdmin) {
        this.num++
      }
      if (localStorage.getItem('TUTORS_VERSIONIO') != this.versionTutorIO) {
        this.num++
      }
      if (
        localStorage.getItem('STAFF_VERSION') != this.versionStaff ||
        localStorage.getItem('TUTORS_VERSIONA') != this.versionTutorA
      ) {
        this.num++
      }
    },
    mapPermits() {
      //Admin
      this.versionAdmin = this.getUser.versions[7].version.split('.')
      for (let a = 0; a < this.versionAdmin.length - 1; a++) {
        this.set = this.set + this.versionAdmin[a] + '.'
      }
      this.versionAdmin = this.set.substring(0, this.set.length - 1)
      this.set = ''
      //Staff
      this.versionStaff = this.getUser.versions[0].version.split('.')
      for (let a = 0; a < this.versionStaff.length - 1; a++) {
        this.set = this.set + this.versionStaff[a] + '.'
      }
      this.versionStaff = this.set.substring(0, this.set.length - 1)
      this.set = ''
      //TutorAndroid
      this.versionTutorA = this.getUser.versions[1].version.split('.')
      for (let a = 0; a < this.versionTutorA.length - 1; a++) {
        this.set = this.set + this.versionTutorA[a] + '.'
      }
      this.versionTutorA = this.set.substring(0, this.set.length - 1)
      this.set = ''
      //TutorIOS
      this.versionTutorIO = this.getUser.versions[2].version.split('.')
      for (let a = 0; a < this.versionTutorIO.length - 1; a++) {
        this.set = this.set + this.versionTutorIO[a] + '.'
      }
      this.versionTutorIO = this.set.substring(0, this.set.length - 1)
      this.set = ''

      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('WATCH')) {
          this.permits[catalogs[c].name] = 1
        }
      }
      this.contUpdate()
      this.$forceUpdate()
    },
    pushRoute(item) {
      if (item.permit != 'WATCH_CART' && this.permits[item.permit])
        this.$router.push(item.route)
    },
    statusUp() {
      if (
        localStorage.getItem('APP_VERSION') == this.versionAdmin ||
        localStorage.getItem('STAFF_VERSION') == this.versionStaff ||
        localStorage.getItem('TUTORS_VERSIONA') == this.versionTutorA ||
        localStorage.getItem('TUTORS_VERSIONIO') == this.versionTutorIO
      ) {
        return false
      } else {
        return true
      }
    },
    teste() {
      localStorage.setItem('APP_VERSION', this.versionAdmin)
      localStorage.setItem('STAFF_VERSION', this.versionStaff)
      localStorage.setItem('TUTORS_VERSIONA', this.versionTutorA)
      localStorage.setItem('TUTORS_VERSIONIO', this.versionTutorIO)
    },
    goWorkshop() {
      this.$router.push('workshop')
    },
    goClassroom() {
      this.$router.push('classroom')
    },
    goHoliday() {
      this.$router.push('holidays')
    },
    _getRoomUuid() {
      if (!this.getBranch || !this.getBranch.id) return
      return `${this.getBranch.id}-dashboard`
    },
    _subscribeWs() {
      const socketRoom = this._getRoomUuid()
      if (socketRoom === undefined) return
      this.$socket.connect()
      console.log('subscribe', socketRoom)
      this.$socket.emit('subscribe', socketRoom)
    },
    _unSubscribeWs() {
      if (this._getRoomUuid() === undefined) return
      const socketRoom = this._getRoomUuid()
      console.log('unsubscribe', socketRoom)
      this.$socket.emit('unsubscribe', socketRoom)
    },
  },
  computed: {
    ...mapGetters(['getUser', 'getBranch']),

    menu() {
      return this.$store.getters.getMenuItems
    },
  },
  sockets: {
    connect(evt) {
      console.log('Connected', evt)
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this._subscribeWs()
    },
    message(notification) {
      console.log(notification)
      switch (`${notification.entity}_${notification.event}`) {
        case 'STUDENT_ENTRY':
          this.dashboardData.capacity = this.dashboardData.capacity + 1

          this.dashboardData.studentEntries =
            this.dashboardData.studentEntries + 1
          break
        case 'STUDENT_EXIT':
          if (this.dashboardData.capacity >= 1) {
            this.dashboardData.capacity = this.dashboardData.capacity - 1
          }

          this.dashboardData.studentDepartures =
            this.dashboardData.studentDepartures + 1
          break
        case 'COLLABORATOR_ENTRY':
          this.dashboardData.capacity = this.dashboardData.capacity + 1

          this.dashboardData.collaboratorEntries =
            this.dashboardData.collaboratorEntries + 1
          break
        case 'COLLABORATOR_EXIT':
          if (this.dashboardData.capacity >= 1) {
            this.dashboardData.capacity = this.dashboardData.capacity - 1
          }

          this.dashboardData.collaboratorDepartures =
            this.dashboardData.collaboratorDepartures + 1
          break
        default:
          console.error('Error on websocket')
          break
      }
    },
  },
}
</script>

<style lang="sass" scoope>
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css")
</style>
<style>
.zoomD {
  background-color: rgb(255, 255, 255);
  transition: transform 0.2s; /* Animation */
  margin: 0 auto;
  text-align: center;
}

.zoomD:hover {
  transform: scale(
    1.02
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  background-color: rgb(255, 255, 255);
}
</style>

<style scoped>
._gray {
  filter: grayscale(100%);
}
.c_row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  width: 100%;
  grid-gap: 10px;
  transition: filter 0.4s ease-out;
  filter: none;
}
::v-deep .v-expansion-panel {
  height: min-content;
}
::v-deep .v-expansion-panel__header {
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
</style>
